import React from "react";
import Button from "@mui/material/Button";
interface ButtonProps{
    id: string,
    label:string,
    onClick: () => void,
    style: React.CSSProperties,
    disabled?: boolean
}

export const ButtonContained: React.FC<ButtonProps> =({id, onClick, label, style, disabled})=>{
    return (       
       <Button variant="contained" id={id} onClick={onClick} sx={style} disabled={disabled}> {label}</Button>
    );
}

